import { DeleteNodeContext } from 'pages/Flow/FlowBuilder/DeleteNodeContextProvider';
import { FlowBuilderContext } from 'pages/Flow/FlowBuilder/FlowBuilderContextProvider';
import { question as questionURL } from 'utils/spaUrls';
import { useContext } from 'react';


export const useActionMenuItems = () => {
  const actionItems = [];
  const { isViewMode } = useContext(FlowBuilderContext);
  const { confirmAction } = useContext(DeleteNodeContext);

  return (node, nodeQuestion, crId) => {
    if (!node || !nodeQuestion || !crId) {
      return [];
    }

    const handleOnDelete = () => {
      confirmAction({
        nodeId: nodeQuestion.nodeId || node?.id,
        title: nodeQuestion.title || node?.data?.title || node?.data?.label || '',
      });
    };

    if (node?.isEditable) {
      actionItems.push({
        label: 'Edit Question',
        link: true,
        action: undefined,
        to: questionURL.builder.wizard.flow(nodeQuestion.ID, crId),
      });
    }

    if (!isViewMode) {
      actionItems.push({
        label: 'Delete',
        link: false,
        action: handleOnDelete,
      });
    }

    return actionItems;
  };
};
